import { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Edit, useDataProvider, useTranslate } from 'react-admin';
import { breakpoints } from '@/themes/themeOverrides/Breakpoints';
import getLoadingState from '@/helpers/ui/getLoadingState.jsx';
import CustomCloseButton from '@/components/global/buttons/CustomCloseButton.jsx';
import { CollectionPointForm } from '@/components/collectionPoint/CollectionPointForm.jsx';
import { Palette } from '@/themes/themeOverrides/Palette';

const StyledCollectionPointEdit = styled(Box)(() => ({
    width: '100%',
    '& .MuiCardContent-root': {
        width: '100%',
        marginBottom: '34px',
    },
    '& .RaShow-noActions': {
        margin: '0',
    },
    '& .popup-wrapper-top': {
        '& .popup-box--header': {
            padding: 0,
        },
    },
    '& .popup-box--header': {
        alignItems: 'center',
    },
    '& .padding-wrapper': {
        borderTop: `2px solid ${Palette.gray.gray75}`,
        padding: '40px 56px 56px',
        [`@media (max-width: ${breakpoints.values.md}px)`]: {
            padding: '24px 20px',
        },
    },
    '& .MuiTypography-root.MuiTypography-h5': {
        fontSize: '22px',
        letterSpacing: '-0.44px',
        marginBottom: '24px',
    },
}));

export const CollectionPointEdit = ({ handleClose, elementId }) => {
    const dataProvider = useDataProvider();
    const translate = useTranslate();
    const [collectionPoint, setCollectionPoint] = useState(null);
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const loadingState = getLoadingState({ isLoading, error, data: collectionPoint, translate });

    useEffect(() => {
        if (elementId) {
            setIsLoading(true);
            dataProvider
                .getOne('collection-point', { id: elementId })
                .then(({ data }) => {
                    setCollectionPoint(data);
                    setError(null);
                })
                .catch(err => {
                    console.error('Error fetching collectionPoint:', err);
                    setError(err);
                })
                .finally(() => {
                    setIsLoading(false);
                });
        }
    }, [dataProvider, elementId]);

    if (loadingState) return loadingState;

    return (
        <StyledCollectionPointEdit>
            <Box className='popup-wrapper popup-wrapper-top'>
                <Box className='popup-box popup-box--header'>
                    <Typography variant='h4'>{translate('resources.collectionPoint.labels.editCollectionPointTitle')}</Typography>
                    <Box>
                        <CustomCloseButton onClose={handleClose} />
                    </Box>
                </Box>
            </Box>
            <Edit id={elementId} resource='collection-point' mutationMode='pessimistic' redirect={false} actions={false} toolbar={false}>
                <Box className='padding-wrapper'>
                    <CollectionPointForm handleClose={handleClose} />
                </Box>
            </Edit>
        </StyledCollectionPointEdit>
    );
};

export default CollectionPointEdit;
